function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define("VueToast", [], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueToast = e() : t.VueToast = e();
}(this, function () {
  return function (t) {
    var e = {};

    function s(o) {
      if (e[o]) return e[o].exports;
      var n = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(n.exports, n, n.exports, s), n.l = !0, n.exports;
    }

    return s.m = t, s.c = e, s.d = function (t, e, o) {
      s.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, s.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, s.t = function (t, e) {
      if (1 & e && (t = s(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var o = Object.create(null);
      if (s.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var n in t) {
        s.d(o, n, function (e) {
          return t[e];
        }.bind(null, n));
      }
      return o;
    }, s.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return s.d(e, "a", e), e;
    }, s.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, s.p = "", s(s.s = 2);
  }({
    2: function _(t, e, s) {
      "use strict";

      s.r(e), s.d(e, "Component", function () {
        return a;
      }), s.d(e, "Positions", function () {
        return i;
      });

      var o = /*#__PURE__*/function () {
        function o(t, e) {
          _classCallCheck(this, o);

          this.startedAt = Date.now(), this.callback = t, this.delay = e, this.timer = setTimeout(t, e);
        }

        _createClass(o, [{
          key: "pause",
          value: function pause() {
            this.stop(), this.delay -= Date.now() - this.startedAt;
          }
        }, {
          key: "resume",
          value: function resume() {
            this.stop(), this.startedAt = Date.now(), this.timer = setTimeout(this.callback, this.delay);
          }
        }, {
          key: "stop",
          value: function stop() {
            clearTimeout(this.timer);
          }
        }]);

        return o;
      }();

      var n,
          i = Object.freeze({
        TOP_RIGHT: "top-right",
        TOP: "top",
        TOP_LEFT: "top-left",
        BOTTOM_RIGHT: "bottom-right",
        BOTTOM: "bottom",
        BOTTOM_LEFT: "bottom-left"
      }),
          r = {
        all: n = n || new Map(),
        on: function on(t, e) {
          var s = n.get(t);
          s && s.push(e) || n.set(t, [e]);
        },
        off: function off(t, e) {
          var s = n.get(t);
          s && s.splice(s.indexOf(e) >>> 0, 1);
        },
        emit: function emit(t, e) {
          (n.get(t) || []).slice().map(function (t) {
            t(e);
          }), (n.get("*") || []).slice().map(function (s) {
            s(t, e);
          });
        }
      };

      var a = function (t, e, s, o, n, i, r, a) {
        var u,
            c = "function" == typeof t ? t.options : t;
        if (e && (c.render = e, c.staticRenderFns = s, c._compiled = !0), o && (c.functional = !0), i && (c._scopeId = "data-v-" + i), r ? (u = function u(t) {
          (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), n && n.call(this, t), t && t._registeredComponents && t._registeredComponents.add(r);
        }, c._ssrRegister = u) : n && (u = a ? function () {
          n.call(this, (c.functional ? this.parent : this).$root.$options.shadowRoot);
        } : n), u) if (c.functional) {
          c._injectStyles = u;
          var l = c.render;

          c.render = function (t, e) {
            return u.call(e), l(t, e);
          };
        } else {
          var p = c.beforeCreate;
          c.beforeCreate = p ? [].concat(p, u) : [u];
        }
        return {
          exports: t,
          options: c
        };
      }({
        name: "toast",
        props: {
          message: {
            type: String,
            required: !0
          },
          type: {
            type: String,
            "default": "success"
          },
          position: {
            type: String,
            "default": i.BOTTOM_RIGHT,
            validator: function validator(t) {
              return Object.values(i).includes(t);
            }
          },
          duration: {
            type: Number,
            "default": 3e3
          },
          dismissible: {
            type: Boolean,
            "default": !0
          },
          onDismiss: {
            type: Function,
            "default": function _default() {}
          },
          onClick: {
            type: Function,
            "default": function _default() {}
          },
          queue: Boolean,
          pauseOnHover: {
            type: Boolean,
            "default": !0
          }
        },
        data: function data() {
          return {
            isActive: !1,
            parentTop: null,
            parentBottom: null,
            isHovered: !1
          };
        },
        beforeMount: function beforeMount() {
          this.setupContainer();
        },
        mounted: function mounted() {
          this.showNotice(), r.on("toast-clear", this.dismiss);
        },
        methods: {
          setupContainer: function setupContainer() {
            if (this.parentTop = document.querySelector(".v-toast.v-toast--top"), this.parentBottom = document.querySelector(".v-toast.v-toast--bottom"), this.parentTop && this.parentBottom) return;
            this.parentTop || (this.parentTop = document.createElement("div"), this.parentTop.className = "v-toast v-toast--top"), this.parentBottom || (this.parentBottom = document.createElement("div"), this.parentBottom.className = "v-toast v-toast--bottom");
            var t = document.body;
            t.appendChild(this.parentTop), t.appendChild(this.parentBottom);
          },
          shouldQueue: function shouldQueue() {
            return !!this.queue && (this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0);
          },
          dismiss: function dismiss() {
            var _arguments = arguments,
                _this = this;

            this.timer.stop(), clearTimeout(this.queueTimer), this.isActive = !1, setTimeout(function () {
              var t;
              _this.onDismiss.apply(null, _arguments), _this.$destroy(), void 0 !== (t = _this.$el).remove ? t.remove() : t.parentNode.removeChild(t);
            }, 150);
          },
          showNotice: function showNotice() {
            this.shouldQueue() ? this.queueTimer = setTimeout(this.showNotice, 250) : (this.correctParent.insertAdjacentElement("afterbegin", this.$el), this.isActive = !0, this.timer = new o(this.dismiss, this.duration));
          },
          whenClicked: function whenClicked() {
            this.dismissible && (this.onClick.apply(null, arguments), this.dismiss());
          },
          toggleTimer: function toggleTimer(t) {
            this.pauseOnHover && (t ? this.timer.pause() : this.timer.resume());
          }
        },
        computed: {
          correctParent: function correctParent() {
            switch (this.position) {
              case i.TOP:
              case i.TOP_RIGHT:
              case i.TOP_LEFT:
                return this.parentTop;

              case i.BOTTOM:
              case i.BOTTOM_RIGHT:
              case i.BOTTOM_LEFT:
                return this.parentBottom;
            }
          },
          transition: function transition() {
            switch (this.position) {
              case i.TOP:
              case i.TOP_RIGHT:
              case i.TOP_LEFT:
                return {
                  enter: "v-toast--fade-in-down",
                  leave: "v-toast--fade-out"
                };

              case i.BOTTOM:
              case i.BOTTOM_RIGHT:
              case i.BOTTOM_LEFT:
                return {
                  enter: "v-toast--fade-in-up",
                  leave: "v-toast--fade-out"
                };
            }
          }
        },
        beforeDestroy: function beforeDestroy() {
          r.off("toast-clear", this.dismiss);
        }
      }, function () {
        var t = this,
            e = t.$createElement,
            s = t._self._c || e;
        return s("transition", {
          attrs: {
            "enter-active-class": t.transition.enter,
            "leave-active-class": t.transition.leave
          }
        }, [s("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.isActive,
            expression: "isActive"
          }],
          staticClass: "v-toast__item",
          "class": ["v-toast__item--" + t.type, "v-toast__item--" + t.position],
          attrs: {
            role: "alert"
          },
          on: {
            mouseover: function mouseover(e) {
              return t.toggleTimer(!0);
            },
            mouseleave: function mouseleave(e) {
              return t.toggleTimer(!1);
            },
            click: t.whenClicked
          }
        }, [s("div", {
          staticClass: "v-toast__icon"
        }), t._v(" "), s("p", {
          staticClass: "v-toast__text",
          domProps: {
            innerHTML: t._s(t.message)
          }
        })])]);
      }, [], !1, null, null, null).exports;

      var u = function u(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return {
          open: function open(s) {
            var o;
            "string" == typeof s && (o = s);
            var n = {
              message: o
            },
                i = Object.assign({}, n, e, s);
            return new (t.extend(a))({
              el: document.createElement("div"),
              propsData: i
            });
          },
          clear: function clear() {
            r.emit("toast-clear");
          },
          success: function success(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.open(Object.assign({}, {
              message: t,
              type: "success"
            }, e));
          },
          error: function error(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.open(Object.assign({}, {
              message: t,
              type: "error"
            }, e));
          },
          info: function info(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.open(Object.assign({}, {
              message: t,
              type: "info"
            }, e));
          },
          warning: function warning(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.open(Object.assign({}, {
              message: t,
              type: "warning"
            }, e));
          },
          "default": function _default(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.open(Object.assign({}, {
              message: t,
              type: "default"
            }, e));
          }
        };
      };

      a.install = function (t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var s = u(t, e);
        t.$toast = s, t.prototype.$toast = s;
      };

      e["default"] = a;
    }
  })["default"];
});